import { render, staticRenderFns } from "./Indexv2.vue?vue&type=template&id=f248f01c&scoped=true&"
import script from "./Indexv2.vue?vue&type=script&lang=js&"
export * from "./Indexv2.vue?vue&type=script&lang=js&"
import style0 from "./Indexv2.vue?vue&type=style&index=0&id=f248f01c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f248f01c",
  null
  
)

export default component.exports